<template lang="pug">
  .option-card(v-if="show")
    font-awesome-icon.icon(:icon="icon")
    p.title {{title}}
    a.close(@click="close") &times;
</template>
<script>
export default {
  props: {
    icon: {
      type: String,
      default: 'stream',
    },
    title: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      show: true,
    }
  },
  methods: {
    close () {
      this.show = false
    },
  },
}
</script>
<style lang="stylus" scoped>
  @import "../../assets/styles/variables.styl"
  .option-card
    min-width 250px
    display flex
    align-items center
    padding 10px
    justify-content space-between
    margin 5px 15px 5px 0
    background-color $primary-color-light-3
    color $default-color
    font-size 90%
    .title
      padding 0 10px
      flex 1
      color $default-color-bold
    .icon
      font-size 125%
      color $default-color-middle

    .close
      font-size 1.5rem
      line-height 1rem
      padding 0.1rem 0.3rem
      color $default-color-bold
      &:hover
        cursor pointer
        color $danger-color

  @media (max-width: $tablet)
    .option-card
      min-width calc(50% - 5px)
      margin 5px 0

  @media (max-width: $mobile)
    .option-card
      min-width 100%
</style>



// WEBPACK FOOTER //
// src/components/record-details/OptionCard.vue